var exports = {
  "Tc": "ChannelUserTag.module__tag___WmNVYU",
  "Dm": "ChannelUserTag.module__tagSm___WmNVYU",
  "ST": "ChannelUserTag.module__tagLg___WmNVYU",
  "Qq": "ChannelUserTag.module__text___WmNVYU",
  "WV": "ChannelUserTag.module__textSm___WmNVYU",
  "j": "ChannelUserTag.module__textLg___WmNVYU",
};

module.exports = exports;
